'use client';

  import { useEffect, useRef } from 'react';
  import { usePathname, useSearchParams } from 'next/navigation';
  import { usePreloader } from '@/contexts/PreloaderContext';

  /**
   * Watches for route changes.
   * Does NOT auto-hide the preloader — each page's content component calls hide()
   * when its data fetch is complete. This gives a safety fallback after 15s.
   */
  export function NavigationEvents() {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const { hide } = usePreloader();
    const initialized = useRef(false);
    const safetyTimer = useRef<ReturnType<typeof setTimeout>>(undefined);

    useEffect(() => {
      if (!initialized.current) { initialized.current = true; return; }
      // Clear any previous safety timeout
      clearTimeout(safetyTimer.current);
      // Safety fallback: hide after 15 s in case a page forgets to call hide()
      safetyTimer.current = setTimeout(() => hide(), 15000);
      return () => clearTimeout(safetyTimer.current);
    }, [pathname, searchParams, hide]);

    return null;
  }
  